  class CustomSlider extends HTMLElement {
    constructor() {
      super();

      this.collectionsSlider = this.querySelector('.updated-featured-products_collection_slider');
      this.collectionTabs = this.querySelectorAll('.updated-featured-products_collection-button');
      this.collections = this.querySelectorAll('.updated-featured-products_collection');

      this.initCollectionSwitching();
      this.initCollectionScrollBar();
      this.initProductSliders();
    }

    initCollectionSwitching() {
      this.collectionTabs.forEach((button) => {
        button.addEventListener('click', () => {
          const handle = button.dataset.collection;

          this.collectionTabs.forEach((b) =>
            b.classList.remove('updated-featured-products_collection-button_active')
          );
          this.collections.forEach((col) =>
            col.classList.add('updated-featured-products_collection_hide')
          );

          const activeCol = this.querySelector(`.updated-featured-products_collection[data-collection="${handle}"]`);
          activeCol.classList.remove('updated-featured-products_collection_hide');
          button.classList.add('updated-featured-products_collection-button_active');

          // сбрасываем слайдер при переключении
          this.resetProductSlider(activeCol);
        });
      });
    }

    resetProductSlider(collectionEl) {
      const scroll = collectionEl.querySelector('.updated-featured-products_scroll');
      scroll.style.transform = `translateX(0px)`;
      const bar = collectionEl.querySelector('.progress-bar-fill');
      if (bar) bar.style.width = `0%`;
    }

    initCollectionScrollBar() {
      const wrapper = this.querySelector('.updated-featured-products_collections_bottom');
      const slider = this.collectionsSlider;
      const progressBar = wrapper.querySelector('.progress-bar-fill');
      const btnLeft = wrapper.querySelector('button[id*="button_left"]');
      const btnRight = wrapper.querySelector('button[id*="button_right"]');
      const scrollStep = this.clientWidth * 0.5;
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      let scrollOffset = 0;
      let isScrolling = false;

      if (maxScroll > 0 && window.innerWidth > 860) {
        wrapper.style.display = 'flex';
      }

      const updateBar = () => {
        const percent = (scrollOffset / maxScroll) * 100;
        progressBar.style.width = `${percent}%`;
      };

      btnLeft?.addEventListener('click', () => {
        if (scrollOffset > 0) {
          scrollOffset -= scrollStep;
          if (scrollOffset < 0) scrollOffset = 0;
          slider.style.transform = `translateX(-${scrollOffset}px)`;
          updateBar();
        }
      });

      btnRight?.addEventListener('click', () => {
        if (scrollOffset < maxScroll) {
          scrollOffset += scrollStep;
          if (scrollOffset > maxScroll) scrollOffset = maxScroll;
          slider.style.transform = `translateX(-${scrollOffset}px)`;
          updateBar();
        }
      });

      slider.addEventListener('wheel', (e) => {
        if (window.innerWidth < 860 || isScrolling || Math.abs(e.deltaX) < 10) return;
        e.preventDefault();
        isScrolling = true;
        const dir = e.deltaX > 0 ? 1 : -1;
        scrollOffset += dir * scrollStep;
        if (scrollOffset < 0) scrollOffset = 0;
        if (scrollOffset > maxScroll) scrollOffset = maxScroll;
        slider.style.transform = `translateX(-${scrollOffset}px)`;
        updateBar();
        setTimeout(() => (isScrolling = false), 100);
      }, { passive: false });
    }

    initProductSliders() {
      this.collections.forEach((collectionEl) => {
        const slider = collectionEl.querySelector('.updated-featured-products_scroll');
        const card = collectionEl.querySelector('.updated-product-card');
        const bar = collectionEl.querySelector('.updated-featured-products_bottom .progress-bar-fill');
        const btnLeft = collectionEl.querySelector('button[id*="button_left"]');
        const btnRight = collectionEl.querySelector('button[id*="button_right"]');
        if (!slider || !card || !btnLeft || !btnRight) return;

        const cardWidth = card.getBoundingClientRect().width;
        const step = cardWidth + 32;
        const visible = Math.floor(slider.clientWidth / step);
        const max = (slider.scrollWidth - visible * step) * -1;
        let offset = 0;
        let isScrolling = false;

        const updateBar = () => {
          const percent = Math.abs(offset / max) * 100;
          if (bar) bar.style.width = `${percent}%`;
        };

        btnLeft.addEventListener('click', () => {
          offset += step;
          if (offset > 0) offset = 0;
          slider.style.transform = `translateX(${offset}px)`;
          updateBar();
        });

        btnRight.addEventListener('click', () => {
          offset -= step;
          if (offset < max) offset = max;
          slider.style.transform = `translateX(${offset}px)`;
          updateBar();
        });

        slider.addEventListener('wheel', (e) => {
          if (window.innerWidth < 860 || isScrolling || Math.abs(e.deltaX) < 10) return;
          e.preventDefault();
          isScrolling = true;
          const dir = e.deltaX > 0 ? -1 : 1;
          offset += dir * step;
          if (offset > 0) offset = 0;
          if (offset < max) offset = max;
          slider.style.transform = `translateX(${offset}px)`;
          updateBar();
          setTimeout(() => (isScrolling = false), 100);
        }, { passive: false });
      });
    }
  }

  customElements.define('custom-slider', CustomSlider);